import { render, staticRenderFns } from "./ListSchoolItem.vue?vue&type=template&id=43b94a71&"
import script from "./ListSchoolItem.vue?vue&type=script&lang=js&"
export * from "./ListSchoolItem.vue?vue&type=script&lang=js&"
import style0 from "./ListSchoolItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TagList: require('/app/components/tag/TagList.vue').default})
